<div class="mtx-drawer-content-wrapper" [style]="_getDrawerSize()">
  <ng-template cdkPortalOutlet></ng-template>
</div>
